import axios from "axios"

const Axios = axios.create({
    baseURL: process.env.REACT_APP_DB_ADDRESS
})

Axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            localStorage.removeItem("jwt")
            window.location.href = "/"
        }
        return Promise.reject(error)
    }
)

export default Axios